import { useState } from "react";
import "./Forgetpassword.css";
import userAPI from "../../context/Api";
// import { useNavigate } from 'react-router-dom';

function ForgotPassword({ onBack }) {
  // const navigate = useNavigate(); 
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [step, setStep] = useState(1);

  const handleSendOtp = async () => {
    try {
      await userAPI.requestPasswordReset(email);
      alert("OTP sent to your email!");
      setStep(2);
    } catch (error) {
      alert(error.response?.data?.error || "Failed to send OTP");
    }
  };

  const handleVerifyOtp = async () => {
    try {
      await userAPI.verifyOtp(email, otp);
      alert("OTP Verification Success");
      setStep(3);
    } catch (error) {
      alert(error.response?.data?.error || "Invalid OTP");
    }
  };

  const handleResetPassword = async () => {
    try {
      await userAPI.resetPassword(email, newPassword);
      alert("Password reset successfully!");
      onBack();

    } catch (error) {
      alert(error.response?.data?.error || "Failed to reset password");
    }
  };

  return (
    <div className="forgot-password-container">
      {step === 1 && (
        <>
          <h2>Forgot Password</h2>
          <input
            type="email"
            placeholder="Enter your admin email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button onClick={handleSendOtp}>Send OTP</button>
        </>
      )}
      {step === 2 && (
        <>
          <h2>Verify OTP</h2>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          <button onClick={handleVerifyOtp}>Verify OTP</button>
        </>
      )}
      {step === 3 && (
        <>
          <h2>Reset Password</h2>
          <input
            type="password"
            placeholder="Enter New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <button onClick={handleResetPassword}>Reset Password</button>
        </>
      )}
      <p className="btn btn-link" onClick={onBack}>
        Back to Login
      </p>

    </div>
  );
}

export default ForgotPassword;
